import { load } from "scrivito"
import {
  BuildingReferenceObj,
  BuildingReferenceObjClass
} from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"

export async function fetchBuildingReferencesByTitle(
  searchTerm: string
): Promise<BuildingReferenceObj[]> {
  const buildingReferences = await load(() =>
    BuildingReferenceObjClass.where("title", "matches", searchTerm).toArray()
  )

  return buildingReferences
}
